import React from "react";

const EmptyBookmarkIllustration = () => (
  <svg className="sv-empty-art" viewBox="0 0 120 120" fill="none" aria-hidden="true">
    <rect x="22" y="16" width="60" height="80" rx="8" fill="#F2E7DA" />
    <rect x="32" y="30" width="38" height="6" rx="3" fill="#E0CDB4" />
    <rect x="32" y="44" width="28" height="6" rx="3" fill="#E0CDB4" />
    <rect x="32" y="58" width="34" height="6" rx="3" fill="#E0CDB4" />
    <path d="M70 10 H94 A6 6 0 0 1 100 16 V74 L82 62 L64 74 V16 A6 6 0 0 1 70 10 Z" fill="#AE6F28" />
    <path
      d="M74 30 L80 36 L92 24"
      stroke="#FFFFFF"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SavedSuppliersEmpty = ({ kind = "empty", onBrowse, onRetry }) => {
  if (kind === "error") {
    return (
      <div className="sv-empty" role="alert">
        <h2>Couldn't load your saved suppliers</h2>
        <p>Check your connection and try again.</p>

        <div className="sv-empty-actions">
          <button type="button" className="sv-btn sv-btn-outline" onClick={onRetry}>
            Try again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="sv-empty" role="status">
      <EmptyBookmarkIllustration />

      <h2>No Saved Suppliers</h2>
      <p>Tap the bookmark on any supplier and it lands here, ready for your next order.</p>

      <div className="sv-empty-actions">
        <button type="button" className="sv-btn sv-btn-primary" onClick={onBrowse}>
          Find Suppliers
        </button>
      </div>
    </div>
  );
};

export default SavedSuppliersEmpty;
